export const URLAPISUBIDA = 'https://generacionmezcal.com/notis/subirimg.php'

export const URLAPISUBIDAVIDEO = 'https://generacionmezcal.com/notis/subirvideo.php'
export const URLCARPETADESTINO = 'https://generacionmezcal.com/notis/'

export const URLAPISUBIDAPDF = 'https://generacionmezcal.com/subirpdf.php'

export const URLCARPETADESTINOPDF = 'https://generacionmezcal.com/notis/'